// extracted by mini-css-extract-plugin
module.exports = {"root":"introduction-component_root__1KGEE"};